import Assignment from '@mui/icons-material/Assignment';
import Code from '@mui/icons-material/Code';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DocumentScanner from '@mui/icons-material/DocumentScanner';
import Event from '@mui/icons-material/Event';
import FormatListBulleted from '@mui/icons-material/FormatListBulleted';
import PersonOutlined from '@mui/icons-material/PersonOutlined';
import ForwardToInbox from '@mui/icons-material/ForwardToInbox';
import { Navigation } from '@toolpad/core/AppProvider';
import { AppAuthentication } from 'shared/types/appTypes';
import Logo from '../assets/images/jarrell.png';
import { firebaseSignOut, signInWithGoogle } from '../firebase/auth';
import { db, functions } from '../firebase/firebaseConfig';

// Helper function to get navigation with dynamic event ID
export const getNavigation = (activeEventId?: string): Navigation => {
  const eventQuery = activeEventId ? `?id=${activeEventId}` : '';

  const baseNavigation: Navigation = [
    {
      kind: 'header',
      title: 'Main items'
    },
    {
      title: 'Home',
      icon: <DashboardIcon />
    },
    {
      segment: 'gigs-by-day',
      title: 'Gigs by Day',
      icon: <Event />
    }
  ];

  // Only include event-specific items when there's an active event
  const eventNavigation: Navigation = activeEventId
    ? [
        {
          segment: `event/talent${eventQuery}`,
          title: 'Event Talent',
          icon: <FormatListBulleted />
        },
        {
          segment: `event/clients${eventQuery}`,
          title: 'Event Clients',
          icon: <PersonOutlined />
        }
      ]
    : [];

  const bottomNavigation: Navigation = [
    {
      segment: 'template-editor',
      title: 'Template Editor',
      icon: <ForwardToInbox />
    },
    {
      segment: 'client-form-editor',
      title: 'Client Form Editor',
      icon: <Assignment />
    },
    {
      segment: 'developer',
      title: 'Developer',
      icon: <Code />
    }
  ];

  return [...baseNavigation, ...eventNavigation, ...bottomNavigation];
};

// Default navigation without event ID (for backwards compatibility)
export const NAVIGATION: Navigation = getNavigation();

export const AUTHENTICATION: AppAuthentication = {
  signIn: signInWithGoogle,
  signOut: firebaseSignOut,
  db,
  functions
};

// Helper function to get branding based on active event
export const getBranding = () => {
  return {
    title: 'Jarrell Entertainment',
    logo: <img src={Logo} alt="Jarrell Entertainment" />
  };
};
